import { makeStyles } from 'tss-react/mui';
import Chip from '@mui/material/Chip';
import type { Group } from '../types/Group';
import type { GroupMember } from '../types/GroupMember';

type Props = {
  membership?: GroupMember;
  group: Group;
};

const useStyles = makeStyles()((theme) => ({
  titleChip: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
    },
  },
}));

const GroupListMembership = ({ group, membership }: Props) => {
  const { classes } = useStyles();

  if (group.found) {
    return null;
  }

  if (membership) {
    if (membership.role === 'OWNER') {
      return (
        <Chip
          label="Owner"
          size="small"
          color="primary"
          className={classes.titleChip}
        />
      );
    }
    if (membership.role === 'MEMBER') {
      return (
        <Chip
          label="Member"
          size="small"
          color="primary"
          variant="outlined"
          className={classes.titleChip}
        />
      );
    }
    if (membership.role === 'REQUESTED') {
      return (
        <Chip
          label="Requested"
          size="small"
          color="primary"
          variant="outlined"
          className={classes.titleChip}
        />
      );
    }
  }

  return null;
};

export default GroupListMembership;
